import { currencySymbol } from '~/shared/constants/currencyData.const'
import { BookingCurrency } from '~/types/booking'

export function getPrefix(currency: BookingCurrency): string {
  return currencySymbol[currency] || '$'
}
